import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=10d30b34&scoped=true"
import script from "./SmallCard.vue?vue&type=script&lang=js"
export * from "./SmallCard.vue?vue&type=script&lang=js"
import style0 from "./SmallCard.vue?vue&type=style&index=0&id=10d30b34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d30b34",
  null
  
)

export default component.exports